import React, {FC, useState} from "react";
import { JobProps } from "utils/types";
import {Button} from "@material-ui/core";
import styles from "../../../hygienist/ShiftDetailPage/ShiftDetail.module.scss";
import {exitReact} from "../../../../utils";
import useActionApi from "../../../../hooks/useActionApi";
import Api from "../../../../api";
import FixedLoader from "components/FixedLoader/FixedLoader";
import clsx from "clsx";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import {ShiftPopup} from "../../../hygienist/ShiftDetailPage/components/index";
import Popup from "../../../../components/Popup";
import { History } from 'history';



interface RequestResubmitModalProps {
  job?: JobProps;
  history?: History;
  expiredOfferId?: number;
}

const RequestResubmitModal: FC<RequestResubmitModalProps> = ({
  job,
  history,
  expiredOfferId,
}) => {
    const [isOpenRequestResubmitModal, setIsOpenRequestResubmitModal] = useState<boolean>(false);

    const [resubmitJobLoading, , requestResubmitOffer] = useActionApi({
        apiMethod: Api.requestResubmitOffer,
        onSuccess: () => {
            if (history) {
                history.push('loading');
                exitReact('home');
            }
        }
    });

    const onRequestResubmit = async () => {
       setIsOpenRequestResubmitModal(false)
        if (expiredOfferId !== undefined) {
            await requestResubmitOffer({ offerId: expiredOfferId })
        }
    }
    return (
        <>
            <Popup opened={isOpenRequestResubmitModal} onClose={() => setIsOpenRequestResubmitModal(false)}>
                <ShiftPopup
                    title={'Request Resubmit?'}
                    submit={'OK'}
                    close={'Cancel'}
                    job={job ?? {} as JobProps}                    
                    onClose={() => setIsOpenRequestResubmitModal(false)}
                    onSubmit={onRequestResubmit}
                />
            </Popup>

            <Button
                className={clsx(styles.statusButton, styles.resubmitShift)}
                onClick={() => setIsOpenRequestResubmitModal(true)}
            >
                <EventAvailableIcon className={styles.confirmedShiftIcon}/>
                Request this offer to be resubmitted
            </Button>

            <FixedLoader
                loading={resubmitJobLoading}
            />
        </> 
    )
}

export default RequestResubmitModal;